import { IconButton, Card, Typography, Stack, Box, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import DataTable from "examples/Tables/DataTable";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Visibility } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { getDiscounts } from "../../../../redux/discount";
import ModalDiscount from "../Modal/ModalDiscount";

const columns = [
  { Header: "name", accessor: "name", width: "20%", align: "left" },
  { Header: "type", accessor: "type", width: "15%", align: "left" },
  { Header: "status", accessor: "status", align: "center" },
  { Header: "start time", accessor: "startTime", align: "center" },
  { Header: "end time", accessor: "endTime", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];

const formatDateTime = (dateStr) => {
  if (!dateStr) return "—";
  return <Typography>{new Date(dateStr).toLocaleString()}</Typography>;
};

const checkStatus = (status, starts_at, ends_at) => {
  if (!status) return ["deactivate", "error"];
  if (starts_at && Date.now() - Date.parse(starts_at) < 0) return ["scheduled", "warning"];
  if (ends_at && Date.now() - Date.parse(ends_at) > 0) return ["expired", "secondary"];
  return ["active", "success"];
};

const TabDiscount = () => {
  const [loading, setLoading] = useState(true);
  const [openModalDiscount, setOpenModalDiscount] = useState(false);
  const [discountIndex, setDiscountIndex] = useState(0);
  const dispatch = useDispatch();
  const shopDomain = useSelector((state) => state.shop.shopDomain);
  const discounts = useSelector((state) => state.discount.list);

  const handleCloseModalDiscount = useCallback(() => {
    setOpenModalDiscount(false);
    setDiscountIndex(0);
  }, []);

  const handleActiveModal = useCallback(
    (index) => () => {
      setDiscountIndex(index);
      setOpenModalDiscount(true);
    },
    []
  );

  useEffect(() => {
    setLoading(true);
    if (shopDomain) {
      dispatch(getDiscounts(shopDomain)).then(() => setLoading(false));
    }
  }, [shopDomain]);

  // Memo hóa rows/table để identity không đổi khi mở modal,
  // tránh react-table reset pageIndex về 0 (autoResetPage).
  const rows = useMemo(
    () =>
      (discounts || []).map(
        (
          { title, discount_type, discount_apply, discount_value, status, starts_at, ends_at },
          index
        ) => {
          const [statusLabel, statusColor] = checkStatus(status, starts_at, ends_at);
          return {
            name: (
              <Stack direction="column" spacing={0.5}>
                <Typography fontWeight="medium">{title}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {discount_apply != "new_price"
                    ? `-${discount_value}${discount_apply === "percentage" ? "%" : "$"}`
                    : `New price: ${discount_value}$`}
                </Typography>
              </Stack>
            ),
            type: (
              <MDBadge
                badgeContent={discount_type}
                color={discount_type === "automatic" ? "info" : "default"}
                variant="gradient"
                size="sm"
              />
            ),
            status: (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent={statusLabel}
                  color={statusColor}
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ),
            startTime: <Typography>{formatDateTime(starts_at)}</Typography>,
            endTime: <Typography>{formatDateTime(ends_at)}</Typography>,
            action: (
              <IconButton color="info" onClick={handleActiveModal(index)}>
                <Visibility />
              </IconButton>
            ),
          };
        }
      ),
    [discounts, handleActiveModal]
  );

  const tableData = useMemo(() => ({ columns, rows }), [rows]);

  return (
    <>
      {shopDomain && (
        <>
          <Card sx={{ marginTop: 3 }}>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <Typography variant="h6" color="whitesmoke">
                Discounts
              </Typography>
            </MDBox>
            <MDBox pt={3}>
              {loading ? (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <CircularProgress color="info" />
                </Box>
              ) : !discounts || discounts.length === 0 ? (
                <Typography align="center">{`Don't have any discount`}</Typography>
              ) : (
                <DataTable
                  table={tableData}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              )}
            </MDBox>
          </Card>
          {openModalDiscount && (
            <ModalDiscount
              active={openModalDiscount}
              onClose={handleCloseModalDiscount}
              dataIndex={discountIndex}
            />
          )}
        </>
      )}
    </>
  );
};

export default TabDiscount;
